import React, { useState, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import aboutBannerImage from '../assets/About/AboutUsBanner.jpg';

import PageBanner from '../ui/PageBanner';
import AboutWelcome from '../components/About/AboutWelcome';
import AboutInfoCards from '../components/About/AboutInfoCards';
import AboutStrengths from '../components/About/AboutStrengths';

import Preloader from '../ui/Preloader';  
const AboutUs = () => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    AOS.init({ duration: 1000, once: false });
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => setLoading(false), 1200);
    return () => clearTimeout(delay);
  }, []);

  return (
    <>
    {loading ? (
      <Preloader />
    ) :(<div className="w-full">
      <PageBanner
        title="About Us"
        breadcrumb="About Us"
        backgroundImage={aboutBannerImage}

      />

<div className="py-6 px-4 md:px-10 bg-white justify-text">
        <div className="text-center mb-12" data-aos="fade-up">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold font-roboto text-gray-900">Welcome to ESMOB Technologies</h2>
          <div className="w-12 h-0.5 bg-[#2584C6] mx-auto mt-2 rounded"></div>
        </div>

        <AboutWelcome />
        <AboutInfoCards />
        <AboutStrengths />
      </div>
    </div>) }
    </>
  );
};

export default AboutUs;
